module.exports = __webpack_public_path__ + "media/dashboard/assets/images/no-document-06d9ce7b0adb6f73c73a45da951a3dae.jpg";